(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bobloom-fabric-chapter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bb-fabric-view')) {
  customElements.define('bb-fabric-view', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const controls = this.querySelector('[data-fabric-controls]');
      if (!controls) return;
      this.dataset.enhanced = 'true';
      controls.hidden = false;
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-fabric-view]');
        if (!button) return;
        const key = button.dataset.fabricView;
        this.querySelectorAll('[data-fabric-panel]').forEach(panel => panel.hidden = panel.dataset.fabricPanel !== key);
        controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    }
  });
}
if (!customElements.get('bb-mood-selector')) {
  customElements.define('bb-mood-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const controls = this.querySelector('[data-mood-controls]');
      const buttons = [...this.querySelectorAll('[data-mood-select]')];
      const panels = [...this.querySelectorAll('[data-mood-panel]')];
      if (!buttons.length || !controls) return;
      const select = (button, announce = true) => {
        const key = button.dataset.moodSelect;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        panels.forEach(panel => panel.hidden = panel.dataset.moodPanel !== key);
        if (announce) {
          const panel = panels.find(panel => panel.dataset.moodPanel === key);
          this.querySelector('[role="status"]').textContent = button.textContent.trim() + ' / ' + panel.querySelector('.bf-mood-description p').textContent.trim() + ' / ' + panel.querySelector('.bf-mood-description span').textContent.trim();
        }
      };
      this.dataset.enhanced = 'true';
      controls.hidden = false;
      select(buttons[0], false);
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-mood-select]');
        if (button) select(button);
      });
    }
  });
}

const openBrowseAnchor = () => {
  if (location.hash !== '#series' && location.hash !== '#season') return;
  const row = document.querySelector('.bf-browse-row' + location.hash);
  if (row) row.open = true;
};
openBrowseAnchor();
window.addEventListener('hashchange', openBrowseAnchor);
if (!customElements.get('bb-signature-selector')) {
  customElements.define('bb-signature-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      const controls = this.querySelector('[data-feature-controls]');
      const buttons = [...this.querySelectorAll('[data-feature-select]')];
      const panels = [...this.querySelectorAll('[data-feature-panel]')];
      if (!controls || !buttons.length) return;
      this.abort = new AbortController();
      const select = (button, announce = true) => {
        panels.forEach(panel => panel.hidden = panel.dataset.featurePanel !== button.dataset.featureSelect);
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        if (announce) this.querySelector('[data-feature-status]').textContent = button.textContent.trim();
      };
      controls.hidden = false;
      this.dataset.enhanced = 'true';
      select(buttons[0], false);
      controls.addEventListener('click', event => {
        const button = event.target.closest('[data-feature-select]');
        if (button) select(button);
      }, {signal:this.abort.signal});
      controls.addEventListener('keydown', event => {
        const current = buttons.indexOf(event.target);
        if (current < 0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[index].focus();
        select(buttons[index]);
      }, {signal:this.abort.signal});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
  });
}
if (!customElements.get('bb-arrival-rail')) {
  customElements.define('bb-arrival-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-arrival-track]');
      this.controls = this.querySelector('[data-arrival-controls]');
      if (!this.track || !this.controls || this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const previous = this.querySelector('[data-arrival-previous]');
      const next = this.querySelector('[data-arrival-next]');
      this.update = () => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = maximum < 2;
        previous.disabled = this.track.scrollLeft < 2;
        next.disabled = this.track.scrollLeft >= maximum - 2;
      };
      const move = direction => {
        const cards = [...this.track.children];
        const origin = this.track.getBoundingClientRect().left;
        const positions = cards.map(card => card.getBoundingClientRect().left - origin + this.track.scrollLeft);
        const current = this.track.scrollLeft;
        const target = direction > 0 ? positions.find(value => value > current + 2) : positions.reverse().find(value => value < current - 2);
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        this.track.scrollTo({left:target ?? (direction > 0 ? this.track.scrollWidth : 0),behavior});
      };
      previous.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      this.track.addEventListener('scroll', this.update, {passive:true,signal});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({left:event.key === 'Home' ? 0 : this.track.scrollWidth});
        else move(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.abort = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
